import { TFunction } from "react-i18next";
import { GraphType, MetaData } from "@services/monitoring/types";

export const getUnit = (
  type: GraphType | undefined,
  customGraph: MetaData | undefined,
  t: TFunction
) => {
  switch (type) {
    case GraphType.Frame_Rate:
    case GraphType.Frame_Rate_Content:
      return t("fps");
    case GraphType.Ping_Latency:
    case GraphType.Jitter_Audio:
    case GraphType.Jitter_Video:
    case GraphType.Jitter_Content:
      return t("ms");
    case GraphType.Packet_Loss_Percentage_Content:
    case GraphType.Cpu:
    case GraphType.Packet_Loss_Content:
    case GraphType.Packet_Loss:
      return "%";
    case GraphType.Call_Rate:
    case GraphType.Bit_Rate_Content:
      return t("Kbps");
    case GraphType.Network:
      return t("Mbps");
    case GraphType.Memory_In_Use:
      return t("GB");
    case GraphType.Port_Usage_Video:
      return "";
    default:
      return customGraph?.unit ?? "";
  }
};
